import omnitureHelper from 'utils/omnitureHelper';
import { template } from 'utils/stringUtils';
import { isEmpty, get } from 'lodash';
import { isDigitsOnly, isValidEmail, isString, isValidIndianMobileNumber } from 'utils/validators';
const loginAnalyticMap = {
    show_signup_popup: {
        value: 'Signup:Displayed',
        customLinkName: 'Signup Displayed'
    },
    show_login_popup: {
        value: 'Login:Displayed',
        customLinkName: 'Login Displayed'
    },
    login_mobile_entered: {
        value: 'Login:Mobile_Entered',
        customLinkName: 'Mobile Entered'
    },
    login_email_entered: {
        value: 'Login:Email_Entered',
        customLinkName: 'Email Entered'
    },
    account_not_exists: {
        value: 'Login:{@loginId}_Does_Not_Exist',
        customLinkName: '{@loginId} does not exist'
    },
    invalid_email_mobile: {
        value: 'Login: Invalid_{@loginId}',
        customLinkName: 'Invalid {@loginId}'
    },
    empty_pwd: {
        value: 'Login:{@loginId}_Empty_Password',
        customLinkName: '{@loginId} Empty Password'
    },
    login_success: {
        value: 'Login:{@loginId}_Successful',
        customLinkName: '{@loginId} Login Success',
        extra: {
            events: 'event5'
        }
    },
    signup_success: {
        value: 'Signup:Mobile_Successful',
        customLinkName: 'Signup Successful',
        extra: {
            events: 'event263'
        }
    },
    signup_failed: {
        value: 'SignUp:SignUp_Failure',
        customLinkName: 'SignUp Failure'
    },
    login_failed: {
        value: 'Login:Failure_Other',
        customLinkName: 'Login Failure_Other'
    },
    login_deactivated_user: {
        value: 'Login:Failure Deactivated User',
        customLinkName: 'Login Failure Deactivated User'
    },
    invalid_login_details: {
        value: 'Login:Incorrect_Password_{@loginId}',
        customLinkName: 'Incorrect Password entered'
    },
    otp_requested: {
        value: 'Signup:Mobile_OTP_Requested',
        customLinkName: 'OTP Requested'
    },
    new_otp_sent: {
        value: 'Signup:Mobile_OTP_Sent',
        customLinkName: 'OTP Sent'
    },
    otp_sent: {
        value: 'Login:Forgot_Password_{@loginId}_OTP_Sent',
        customLinkName: 'OTP Sent'
    },
    new_otp_verification_failed: {
        value: 'Signup:{@loginId} Incorrect_OTP_Entered_{@attempt}',
        customLinkName: 'Incorrect OTP Entered'
    },
    otp_verification_failed: {
        value: 'Login:Forgot_Password_{@loginId} Incorrect_OTP_Entered_{@attempt}',
        customLinkName: 'Incorrect OTP Entered'
    },
    otp_verification_failed_other: {
        value: 'Login:Forgot_Password_{@loginId} Incorrect_OTP_Entered_Other',
        customLinkName: 'Incorrect OTP Entered Other'
    },
    otp_entered_login: {
        value: 'Login:Forgot_Password_{@loginId}_OTP_Entered',
        customLinkName: 'OTP Entered'
    },
    otp_entered_signup: {
        value: 'Signup:Mobile_OTP_Entered',
        customLinkName: 'OTP Entered'
    },
    otp_verified: {
        value: 'Login:Forgot_Password_{@loginId}_OTP_Correct',
        customLinkName: 'Correct OTP entered'
    },
    signup_otp_verified: {
        value: 'Signup:Mobile_OTP_Correct',
        customLinkName: 'Correct OTP entered'
    },
    forgot_btn_clicked: {
        value: 'Login:Forgot_Password_{@loginId}_Clicked',
        customLinkName: 'Forgot Password {@loginId}'
    },
    user_registered: {
        value: 'Signup:Mobile_Entered_Already_Exists',
        customLinkName: 'Number already exists'
    },
    signup_btn_clicked: {
        value: 'Signup:Continue_clicked',
        customLinkName: 'Signup Continue Clicked'
    },
    reset_pwd_success: {
        value: 'Login:Forgot_Password_{@loginId}_Successful',
        customLinkName: 'Password reset successfully',
        extra: {
            events: 'event5'
        }
    },
    signup_resend_otp_clicked: {
        value: 'Signup:Mobile_Resend_OTP',
        customLinkName: 'Resend OTP clicked'
    },
    resend_otp_clicked: {
        value: 'Login:Forgot_Password_{@loginId}_Resend_OTP',
        customLinkName: 'Resend OTP clicked'
    },
    otp_request_btn_clicked: {
        value: 'Login: LOGINWITHOTP_{@loginId}_Clicked',
        customLinkName: 'Login with OTP'
    },
    login_otp_sent: {
        value: 'Login: LOGINWITHOTP_{@loginId}_Sent',
        customLinkName: 'OTP Sent'
    },
    loginwith_otp_entered: {
        value: 'Login: LOGINWITHOTP_{@loginId}_Entered',
        customLinkName: 'OTP Entered'
    },
    loginwith_otp_incorrect: {
        value: 'Login: LOGINWITHOTP_{@loginId}_Incorrect',
        customLinkName: 'Incorrect OTP Entered'
    },
    loginwith_resend_otp_clicked: {
        value: 'Login: LOGINWITHOTP_{@loginId}_Resend',
        customLinkName: 'Resend OTP clicked'
    },
    login_otp_success: {
        value: 'Login: LOGINWITHOTP_{@loginId}_Success',
        customLinkName: 'OTP Login Success',
        extra: {
            events: 'event5'
        }
    },
    loginverify_same_password: {
        value: 'Login:Forgot_Password_{@loginId}_Error_Same_Pwd',
        customLinkName: 'Same Password Entered'
    },
    loginverify_otp_expired: {
        value: 'Login:Forgot_Password_{@loginId}_Otp_Expired',
        customLinkName: 'OTP Expired'
    },
    login_modal_exit: {
        value: 'Login:Displayed Exit',
        customLinkName: 'Login Displayed Exit'
    }
};
const checkoutLoginAnalyticMap = {
    show_signup_popup: {
        value: 'Signup:Displayed',
        customLinkName: 'Signup Displayed'
    },
    show_login_popup: {
        value: 'Login2Step:Displayed',
        customLinkName: 'Login2Step Displayed'
    },
    checkout_password_shown: {
        value: 'Login2Step:{@loginId}_Existing_EnterPassword',
        customLinkName: 'Enter Password'
    },
    empty_pwd: {
        value: 'Login2Step:{@loginId}_Empty_Password',
        customLinkName: '{@loginId} Empty Password'
    },
    forgot_btn_clicked: {
        value: 'Login2Step:Forgot_Password_{@loginId}_Clicked',
        customLinkName: 'Forgot Password {@loginId}'
    },
    otp_verified: {
        value: 'Login2Step:Forgot_Password_{@loginId}_OTP_Correct',
        customLinkName: 'Correct OTP entered'
    },
    signup_otp_verified: {
        value: 'Login2Step SIGNUP:Mobile_OTP_Correct',
        customLinkName: 'Correct OTP entered'
    },
    new_otp_verification_failed: {
        value: 'Login2Step SIGNUP:Mobile Incorrect_OTP_Entered_{@attempt}',
        customLinkName: 'Incorrect OTP Entered'
    },
    otp_verification_failed: {
        value: 'Login2Step:Forgot_Password_{@loginId} Incorrect_OTP_Entered_{@attempt}',
        customLinkName: 'Incorrect OTP Entered'
    },
    otp_verification_failed_other: {
        value: 'Login2Step:Forgot_Password_{@loginId} Incorrect_OTP_Entered_Other',
        customLinkName: 'Incorrect OTP Entered Other'
    },
    reset_pwd_success: {
        value: 'Login2Step:Forgot_Password_{@loginId}_Successful',
        customLinkName: 'Password reset successfully',
        extra: {
            events: 'event5'
        }
    },
    login_success: {
        value: 'Login2Step:{@loginId}_Successful',
        customLinkName: '{@loginId} Login Success',
        extra: {
            events: 'event5'
        }
    },
    signup_success: {
        value: 'Login2Step Signup:Mobile_Successful',
        customLinkName: 'Signup Successful',
        extra: {
            events: 'event263'
        }
    },
    signup_failed: {
        value: 'Login2Step SignUp Failure',
        customLinkName: 'SignUp Failure'
    },
    resend_otp_clicked: {
        value: 'Login2Step:Forgot_Password_{@loginId}_OTP_Resend',
        customLinkName: 'Resend OTP clicked'
    },
    signup_resend_otp_clicked: {
        value: 'Login2Step SIGNUP:Mobile_Resend_OTP',
        customLinkName: 'Resend OTP clicked'
    },
    email_signup: {
        value: 'Login2Step Signup:New_Email_Enter_Mobile',
        customLinkName: 'Signup Continue clicked Email Entered'
    },
    mobile_signup: {
        value: 'Login2Step Signup:Mobile_Entered',
        customLinkName: 'Signup Continue Clicked Mobile entered'
    },
    otp_requested: {
        value: 'Login2Step Signup:Mobile_OTP_Requested',
        customLinkName: 'OTP Requested'
    },
    new_otp_sent: {
        value: 'Login2Step Signup:Mobile_OTP_Sent',
        customLinkName: 'OTP Sent'
    },
    otp_sent: {
        value: 'Login2Step:Forgot_Password_{@loginId}_OTP_Sent',
        customLinkName: 'OTP Sent'
    },
    account_not_exists: {
        value: 'Login2Step:{@loginId}_Does_Not_Exist',
        customLinkName: '{@loginId} does not exist'
    },
    invalid_email_mobile: {
        value: 'Login2Step Invalid_{@loginId}',
        customLinkName: 'Invalid {@loginId}',
        extra: {
            prop74: 'Login2Step Invalid_Email/Mobile'
        }
    },
    invalid_login_details: {
        value: 'Login2Step:Incorrect_Password_{@loginId}',
        customLinkName: 'Incorrect Password entered',
        extra: {
            prop74: 'Login2Step:Incorrect_Password'
        }
    },
    login_failed: {
        value: 'Login2Step:Failure_Other',
        customLinkName: 'Login Failure_Other'
    },
    login_deactivated_user: {
        value: 'Login2Step:Failure Deactivated User',
        customLinkName: 'Login Failure Deactivated User'
    },
    otp_request_btn_clicked: {
        value: 'Login2Step: LOGINWITHOTP_{@loginId}_Clicked',
        customLinkName: 'Login with OTP'
    },
    login_otp_sent: {
        value: 'Login2Step: LOGINWITHOTP_{@loginId}_Sent',
        customLinkName: 'OTP Sent'
    },
    loginwith_otp_entered: {
        value: 'Login2Step: LOGINWITHOTP_{@loginId}_Entered',
        customLinkName: 'OTP Entered'
    },
    loginwith_otp_incorrect: {
        value: 'Login2Step: LOGINWITHOTP_{@loginId}_Incorrect',
        customLinkName: 'Incorrect OTP Entered'
    },
    loginwith_resend_otp_clicked: {
        value: 'Login2Step: LOGINWITHOTP_{@loginId}_Resend',
        customLinkName: 'Resend OTP clicked'
    },
    login_otp_success: {
        value: 'Login2Step: LOGINWITHOTP_{@loginId}_Success',
        customLinkName: 'OTP Login Success',
        extra: {
            events: 'event5'
        }
    },
    login_modal_exit: {
        value: 'Login2Step:Displayed Exit',
        customLinkName: 'Login2Step Displayed Exit'
    }
};
// Prop21 Syntax: <PageType_loginSource> <Flow>:<Stage>
export const trackLoginSignupActions = (actionType, trackingData, linkName = 'Verification Flow', map = loginAnalyticMap, defaultAnalyticProp = {}) => {
    let data = null;
    let customLinkName = '';
    if (actionType === 'custom') {
        // Can be use to send multiple prop types in custom manner
        data = trackingData;
        customLinkName = linkName;
    }
    else if (map[actionType]) {
        let value = '';
        const pageType = get(trackingData, 'pageType', '');
        const loginSource = get(trackingData, 'loginSource', '');
        // Prefix pageType and loginSource to prop values.
        if (pageType)
            value += `${pageType}_`;
        if (loginSource)
            value += `${loginSource} `;
        // Check whether its object or plain string, and set the prop value and tracking string accordingly
        if (typeof map[actionType] === 'object') {
            value += map[actionType].value;
        }
        else {
            value += map[actionType];
        }
        // Extract other props and values from templates.
        const { prop = 'prop21', extra = {} } = map[actionType];
        data = Object.assign({}, defaultAnalyticProp, extra, {
            [prop]: trackingData ? template(value, trackingData) : value
        });
        // Extract customLinkName from template
        customLinkName =
            trackingData && trackingData.loginId && map[actionType]
                ? template(map[actionType].customLinkName, trackingData)
                : map[actionType].customLinkName;
    }
    data && omnitureHelper.trackLink(data, customLinkName);
};
export function checkoutLoginActions(actionType, trackingData) {
    trackLoginSignupActions(actionType, trackingData, 'Login2step flow', checkoutLoginAnalyticMap);
}
export function smartlockLoginActions(data) {
    !isEmpty(data) && omnitureHelper.trackSmartLockLogin(data);
}
export function getOmnitureLoginId(loginId) {
    if (!loginId)
        return '';
    if (isDigitsOnly(loginId) || isValidIndianMobileNumber(loginId)) {
        return 'Mobile';
    }
    else if (isValidEmail(loginId) || isString(loginId)) {
        return 'Email';
    }
    return '';
}
